import { render, staticRenderFns } from "./Autorizaciones.vue?vue&type=template&id=499c2326&scoped=true"
import script from "./Autorizaciones.vue?vue&type=script&lang=js"
export * from "./Autorizaciones.vue?vue&type=script&lang=js"
import style0 from "./Autorizaciones.vue?vue&type=style&index=0&id=499c2326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499c2326",
  null
  
)

export default component.exports